import SvgIcon from '@/components/SvgIcon.vue'
import AppLoading from '@/components/AppLoading.vue'
import BaseIconButton from '@/components/UI/button/BaseIconButton.vue'
import StatusBadge from '@/components/StatusBadge.vue'
import type { App } from 'vue'

const globalComponents = (app: App) => {
  app.component('SvgIcon', SvgIcon)
  app.component('AppLoading', AppLoading)
  app.component('BaseIconButton', BaseIconButton)
  app.component('StatusBadge', StatusBadge)
}

export default globalComponents
